import policies from './models/PoliciesHelper';
import userPolicies from './models/UserPoliciesHelper';

export default {
  policies,
  userPolicies,
};
